import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { toast } from 'sonner';
import { Button } from '../../../../web/components/Button';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { Input } from '../../../../web/components-v2/Input';
import { XIcon } from '../../../../web/components/svgs/icons/XIcon';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { useGamification } from '../../../hooks';
import { useResponseHandler } from '../../../hooks/error';
import { useInput } from '../../../hooks/input';
import { white } from '../../../styles/colors';
import { MemeViewModel } from '../../../viewModels/memes';
import { TransparentButton } from '../../TransparentButton';
import { EyeIcon } from '../../svgs/icons/EyeIcon';
import { MemeFile } from '../MemeFile';
import { styleSheet } from './styles';

interface IProps {
	meme: MemeViewModel;
	onDeleteClick?(id: string): () => void;
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const Meme: React.FC<IProps> = props => {
	const { className, meme, onDeleteClick, styles = [] } = props;
	const [phrase, , setPhrase] = useInput(meme.phrase);
	const gamification = useGamification();
	const [updatePhraseResponseHandler] = useResponseHandler('UpdatePhrase-Error', "Unable to update meme's text");
	const [updateImageResponseHandler] = useResponseHandler('UpdateImage-Error', "Unable to update meme's image");
	const [updateSoundResponseHandler] = useResponseHandler('UpdateSound-Error', "Unable to update meme's sound");

	const savePhrase = () => {
		meme
			.updatePhrase(phrase)

			.then(() => toast.success('Text updated'))
			.catch(updatePhraseResponseHandler);
	};

	const onPreview = () => {
		gamification.setMeme(meme);
	};

	const onImageSelected = (file: File) => {
		meme
			.updateImage(file)

			.then(() => toast.success('Image updated'))
			.catch(updateImageResponseHandler);
	};

	const onSoundSelected = (file: File) => {
		meme
			.updateSound(file)

			.then(() => toast.success('Sound updated'))
			.catch(updateSoundResponseHandler);
	};

	if (meme.isBusy) {
		return (
			<div className={`${css(styleSheet.container, ...styles)} meme ${className || ''}`}>
				<div className={css(baseStyleSheet.flexCenter, styleSheet.loader)}>
					<LoadingSpinner type='small' />
				</div>
			</div>
		);
	}

	return (
		<div className={`${css(styleSheet.container, ...styles)} meme ${className || ''}`}>
			<div className={css(styleSheet.xIconContainer)}>
				<TransparentButton onClick={onDeleteClick(meme.id)}>
					<XIcon color={white} height={12} width={12} />
				</TransparentButton>
			</div>
			<div className={css(styleSheet.fileContainer)}>
				<MemeFile meme={meme} label='image:' url={meme.image?.url} onFileSelected={onImageSelected} accept='.png' />
				<MemeFile meme={meme} label='sound:' url={meme.sound?.url} onFileSelected={onSoundSelected} accept='.mp3' />
			</div>
			<div className={css(styleSheet.textContainer)}>
				<div className={css(styleSheet.phraseLabel)}>Text:</div>
				<div>
					<Input styles={[styleSheet.input]} id={meme.id} type='text' value={phrase} onChange={setPhrase} />
				</div>
				<div>
					<Button label='Save' size='small' onClick={savePhrase} />
				</div>
				<div>
					<TransparentButton onClick={onPreview}>
						<EyeIcon />
					</TransparentButton>
				</div>
			</div>
		</div>
	);
};
